import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export const getEthnicities = async () => fetcher.get({ path: '/ethnicities' });
